import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  public getServerErrorMessage(error: HttpErrorResponse): string | undefined {
    if (error) {
      // handle your auth error or rethrow
      if ([401, 403].includes(error.status)) {
        return "Vous n'avez pas l'autorisation d'effectuer cette action.";
      } else if (error.status >= 500) {
        return 'Une erreur serveur est survenue, merci de réessayer plus tard.';
      } else if (error.status === 400) {
        return 'Données incorrectes.';
      } else if (error.status === 433) {
        return "L'utilisateur que vous tentez de créer existe déjà avec cette adresse mail.";
      }
    }
    return undefined;
  }
}
